import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Cell } from 'recharts';
const ProductLinePerformanceDashboard: React.FC = () => {
  const productLineKPIs = [{
    line: 'Lighting',
    revenue: '₹2,620 Cr',
    margin: '18.5%',
    asp: '₹1,245',
    change: '+5.2%',
    isPositive: true
  }, {
    line: 'Electrical',
    revenue: '₹3,185 Cr',
    margin: '19.2%',
    asp: '₹985',
    change: '+7.8%',
    isPositive: true
  }, {
    line: 'Polymer',
    revenue: '₹2,075 Cr',
    margin: '15.8%',
    asp: '₹1,420',
    change: '+3.5%',
    isPositive: true
  }, {
    line: 'Safety',
    revenue: '₹1,370 Cr',
    margin: '17.4%',
    asp: '₹2,180',
    change: '+4.2%',
    isPositive: true
  }];
  const revenueTrendData = [{
    month: 'Jan',
    Lighting: 210,
    Electrical: 255,
    Polymer: 168,
    Safety: 110
  }, {
    month: 'Feb',
    Lighting: 215,
    Electrical: 262,
    Polymer: 172,
    Safety: 113
  }, {
    month: 'Mar',
    Lighting: 222,
    Electrical: 268,
    Polymer: 178,
    Safety: 116
  }, {
    month: 'Apr',
    Lighting: 218,
    Electrical: 265,
    Polymer: 175,
    Safety: 114
  }, {
    month: 'May',
    Lighting: 225,
    Electrical: 272,
    Polymer: 182,
    Safety: 118
  }, {
    month: 'Jun',
    Lighting: 228,
    Electrical: 278,
    Polymer: 185,
    Safety: 120
  }, {
    month: 'Jul',
    Lighting: 232,
    Electrical: 282,
    Polymer: 188,
    Safety: 122
  }, {
    month: 'Aug',
    Lighting: 238,
    Electrical: 288,
    Polymer: 192,
    Safety: 125
  }, {
    month: 'Sep',
    Lighting: 235,
    Electrical: 285,
    Polymer: 190,
    Safety: 123
  }, {
    month: 'Oct',
    Lighting: 242,
    Electrical: 292,
    Polymer: 195,
    Safety: 127
  }, {
    month: 'Nov',
    Lighting: 248,
    Electrical: 298,
    Polymer: 198,
    Safety: 130
  }, {
    month: 'Dec',
    Lighting: 255,
    Electrical: 305,
    Polymer: 202,
    Safety: 132
  }];
  const costBreakdownData = [{
    category: 'Revenue',
    value: 9250,
    type: 'total'
  }, {
    category: 'Raw Material',
    value: -5350,
    type: 'cost'
  }, {
    category: 'Labour',
    value: -1265,
    type: 'cost'
  }, {
    category: 'Manufacturing OH',
    value: -925,
    type: 'cost'
  }, {
    category: 'Logistics',
    value: -485,
    type: 'cost'
  }, {
    category: 'Other Costs',
    value: -318,
    type: 'cost'
  }, {
    category: 'Gross Profit',
    value: 907,
    type: 'profit'
  }];
  const profitabilityData = [{
    line: 'Lighting',
    min: 14.2,
    q1: 16.5,
    median: 18.5,
    q3: 20.2,
    max: 22.8,
    avg: 18.5
  }, {
    line: 'Electrical',
    min: 15.8,
    q1: 17.5,
    median: 19.2,
    q3: 21.0,
    max: 24.5,
    avg: 19.2
  }, {
    line: 'Polymer',
    min: 12.5,
    q1: 14.2,
    median: 15.8,
    q3: 17.5,
    max: 19.8,
    avg: 15.8
  }, {
    line: 'Safety',
    min: 14.8,
    q1: 16.2,
    median: 17.4,
    q3: 18.8,
    max: 21.2,
    avg: 17.4
  }];
  const skuData = [{
    productLine: 'Lighting',
    sku: 'LED Headlamp - Premium',
    revenue: 485,
    cost: 395,
    margin: 18.6,
    volume: 125000
  }, {
    productLine: 'Lighting',
    sku: 'Tail Lamp Assembly',
    revenue: 425,
    cost: 348,
    margin: 18.1,
    volume: 185000
  }, {
    productLine: 'Lighting',
    sku: 'Fog Lamp Kit',
    revenue: 380,
    cost: 312,
    margin: 17.9,
    volume: 95000
  }, {
    productLine: 'Lighting',
    sku: 'Interior LED Strip',
    revenue: 285,
    cost: 235,
    margin: 17.5,
    volume: 220000
  }, {
    productLine: 'Electrical',
    sku: 'Wiring Harness - Main',
    revenue: 625,
    cost: 505,
    margin: 19.2,
    volume: 165000
  }, {
    productLine: 'Electrical',
    sku: 'ECU Module',
    revenue: 585,
    cost: 472,
    margin: 19.3,
    volume: 88000
  }, {
    productLine: 'Electrical',
    sku: 'Alternator Assembly',
    revenue: 495,
    cost: 402,
    margin: 18.8,
    volume: 125000
  }, {
    productLine: 'Electrical',
    sku: 'Battery Management System',
    revenue: 425,
    cost: 345,
    margin: 18.8,
    volume: 72000
  }, {
    productLine: 'Polymer',
    sku: 'Bumper - Front',
    revenue: 385,
    cost: 325,
    margin: 15.6,
    volume: 145000
  }, {
    productLine: 'Polymer',
    sku: 'Dashboard Panel',
    revenue: 365,
    cost: 308,
    margin: 15.6,
    volume: 168000
  }, {
    productLine: 'Polymer',
    sku: 'Door Trim Set',
    revenue: 325,
    cost: 275,
    margin: 15.4,
    volume: 195000
  }, {
    productLine: 'Polymer',
    sku: 'Wheel Arch Liner',
    revenue: 285,
    cost: 242,
    margin: 15.1,
    volume: 225000
  }, {
    productLine: 'Safety',
    sku: 'Airbag Module - Driver',
    revenue: 425,
    cost: 352,
    margin: 17.2,
    volume: 95000
  }, {
    productLine: 'Safety',
    sku: 'Seat Belt Assembly',
    revenue: 365,
    cost: 302,
    margin: 17.3,
    volume: 185000
  }, {
    productLine: 'Safety',
    sku: 'ABS Sensor Kit',
    revenue: 285,
    cost: 236,
    margin: 17.2,
    volume: 142000
  }, {
    productLine: 'Safety',
    sku: 'Child Seat Anchor',
    revenue: 195,
    cost: 160,
    margin: 17.9,
    volume: 220000
  }];
  const aspTrendData = [{
    month: 'Jan',
    Lighting: 1205,
    Electrical: 952,
    Polymer: 1385,
    Safety: 2125
  }, {
    month: 'Feb',
    Lighting: 1212,
    Electrical: 958,
    Polymer: 1392,
    Safety: 2138
  }, {
    month: 'Mar',
    Lighting: 1218,
    Electrical: 965,
    Polymer: 1398,
    Safety: 2145
  }, {
    month: 'Apr',
    Lighting: 1225,
    Electrical: 972,
    Polymer: 1405,
    Safety: 2152
  }, {
    month: 'May',
    Lighting: 1232,
    Electrical: 978,
    Polymer: 1412,
    Safety: 2165
  }, {
    month: 'Jun',
    Lighting: 1245,
    Electrical: 985,
    Polymer: 1420,
    Safety: 2180
  }];
  const getLineColor = (line: string) => {
    switch (line) {
      case 'Lighting':
        return '#3b82f6';
      case 'Electrical':
        return '#10b981';
      case 'Polymer':
        return '#f59e0b';
      case 'Safety':
        return '#ef4444';
      default:
        return '#6b7280';
    }
  };
  return <div data-id="element-8847">
      <DescriptionPanel title="Product Line Performance Analysis" description="Detailed profitability and performance analysis across all product lines. Track revenue trends, cost structures, margin dynamics, and SKU-level performance to optimize product portfolio strategy." insights={['Electrical products leading revenue at ₹3,185 Cr with highest margin (19.2%)', 'Safety products command premium ASP at ₹2,180 - opportunity for volume growth', 'Polymer line margin improvement needed - currently at 15.8% vs 18.5% target', 'Raw materials represent 57.8% of total cost - key focus area for optimization']} data-id="element-8848" />
      {/* Product Line KPI Grid */}
      <div className="mb-8" data-id="element-8849">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-8850">
          Product Line Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-8851">
          {productLineKPIs.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50 border-l-4" style={{
          borderLeftColor: getLineColor(kpi.line)
        }} data-id="element-8852">
              <div className="text-sm font-bold text-gray-600 uppercase tracking-wide mb-3" data-id="element-8853">
                {kpi.line}
              </div>
              <div className="space-y-2" data-id="element-8854">
                <div data-id="element-8855">
                  <div className="text-xs text-gray-500" data-id="element-8856">Revenue</div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-8857">
                    {kpi.revenue}
                  </div>
                </div>
                <div className="flex items-center justify-between" data-id="element-8858">
                  <div data-id="element-8859">
                    <div className="text-xs text-gray-500" data-id="element-8860">Margin</div>
                    <div className="text-lg font-semibold text-green-600" data-id="element-8861">
                      {kpi.margin}
                    </div>
                  </div>
                  <div data-id="element-8862">
                    <div className="text-xs text-gray-500" data-id="element-8863">ASP</div>
                    <div className="text-lg font-semibold text-gray-800" data-id="element-8864">
                      {kpi.asp}
                    </div>
                  </div>
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-8865">
                  {kpi.isPositive ? <TrendingUpIcon size={14} className="mr-1" data-id="element-8866" /> : <TrendingDownIcon size={14} className="mr-1" data-id="element-8867" />}
                  {kpi.change} YoY
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Revenue Trend Multi-Series Chart */}
      <Card className="p-6 mb-8" data-id="element-8868">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8869">
          Revenue Trend by Product Line (₹ Cr)
        </h3>
        <ResponsiveContainer width="100%" height={350} data-id="element-8870">
          <LineChart data={revenueTrendData} data-id="element-8871">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8872" />
            <XAxis dataKey="month" tick={{
            fontSize: 12
          }} data-id="element-8873" />
            <YAxis tick={{
            fontSize: 12
          }} data-id="element-8874" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} data-id="element-8875" />
            <Legend data-id="element-8876" />
            <Line type="monotone" dataKey="Lighting" stroke="#3b82f6" strokeWidth={3} name="Lighting" dot={{
            r: 4
          }} data-id="element-8877" />
            <Line type="monotone" dataKey="Electrical" stroke="#10b981" strokeWidth={3} name="Electrical" dot={{
            r: 4
          }} data-id="element-8878" />
            <Line type="monotone" dataKey="Polymer" stroke="#f59e0b" strokeWidth={3} name="Polymer" dot={{
            r: 4
          }} data-id="element-8879" />
            <Line type="monotone" dataKey="Safety" stroke="#ef4444" strokeWidth={3} name="Safety" dot={{
            r: 4
          }} data-id="element-8880" />
          </LineChart>
        </ResponsiveContainer>
      </Card>
      {/* Cost Breakdown Waterfall and ASP Trend */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-8881">
        <Card className="p-6" data-id="element-8882">
          <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8883">
            Cost Breakdown Waterfall (₹ Cr)
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-8884">
            <BarChart data={costBreakdownData} data-id="element-8885">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8886" />
              <XAxis dataKey="category" tick={{
              fontSize: 10,
              angle: -15,
              textAnchor: 'end'
            }} height={80} data-id="element-8887" />
              <YAxis tick={{
              fontSize: 12
            }} data-id="element-8888" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} formatter={(value: number) => `₹${Math.abs(value)} Cr`} data-id="element-8889" />
              <Bar dataKey="value" data-id="element-8890">
                {costBreakdownData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.type === 'total' ? '#3b82f6' : entry.type === 'profit' ? '#10b981' : '#ef4444'} data-id="element-8891" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200 grid grid-cols-3 gap-2 text-xs" data-id="element-8892">
            <div className="flex items-center" data-id="element-8893">
              <div className="w-3 h-3 bg-blue-500 rounded mr-2" data-id="element-8894" />
              <span className="text-gray-600" data-id="element-8895">Revenue</span>
            </div>
            <div className="flex items-center" data-id="element-8896">
              <div className="w-3 h-3 bg-red-500 rounded mr-2" data-id="element-8897" />
              <span className="text-gray-600" data-id="element-8898">Costs</span>
            </div>
            <div className="flex items-center" data-id="element-8899">
              <div className="w-3 h-3 bg-green-500 rounded mr-2" data-id="element-8900" />
              <span className="text-gray-600" data-id="element-8901">Profit</span>
            </div>
          </div>
        </Card>
        <Card className="p-6" data-id="element-8902">
          <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8903">
            Average Selling Price Trend (₹)
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-8904">
            <LineChart data={aspTrendData} data-id="element-8905">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8906" />
              <XAxis dataKey="month" tick={{
              fontSize: 12
            }} data-id="element-8907" />
              <YAxis tick={{
              fontSize: 12
            }} data-id="element-8908" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} data-id="element-8909" />
              <Legend data-id="element-8910" />
              <Line type="monotone" dataKey="Lighting" stroke="#3b82f6" strokeWidth={2} name="Lighting" dot={{
              r: 3
            }} data-id="element-8911" />
              <Line type="monotone" dataKey="Electrical" stroke="#10b981" strokeWidth={2} name="Electrical" dot={{
              r: 3
            }} data-id="element-8912" />
              <Line type="monotone" dataKey="Polymer" stroke="#f59e0b" strokeWidth={2} name="Polymer" dot={{
              r: 3
            }} data-id="element-8913" />
              <Line type="monotone" dataKey="Safety" stroke="#ef4444" strokeWidth={2} name="Safety" dot={{
              r: 3
            }} data-id="element-8914" />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </div>
      {/* Product Line Profitability Boxplot */}
      <Card className="p-6 mb-8" data-id="element-8915">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8916">
          Product Line Profitability Distribution (Margin %)
        </h3>
        <ResponsiveContainer width="100%" height={300} data-id="element-8917">
          <ComposedChart data={profitabilityData} layout="vertical" data-id="element-8918">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8919" />
            <XAxis type="number" domain={[10, 26]} tick={{
            fontSize: 12
          }} data-id="element-8920" />
            <YAxis dataKey="line" type="category" width={100} tick={{
            fontSize: 12
          }} data-id="element-8921" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} data-id="element-8922" />
            <Bar dataKey="median" fill="#3b82f6" name="Median Margin" data-id="element-8923" />
          </ComposedChart>
        </ResponsiveContainer>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8924">
          <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-8925">
            {profitabilityData.map((item, index) => <div key={index} className="text-center" data-id="element-8926">
                <div className="text-xs text-gray-500 mb-1" data-id="element-8927">{item.line}</div>
                <div className="text-xs text-gray-600" data-id="element-8928">
                  Range: {item.min}% - {item.max}%
                </div>
                <div className="text-sm font-semibold text-gray-800" data-id="element-8929">
                  Avg: {item.avg}%
                </div>
              </div>)}
          </div>
        </div>
      </Card>
      {/* Key SKUs Table */}
      <Card className="p-6" data-id="element-8930">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8931">
          Key SKUs by Product Line
        </h3>
        <div className="overflow-x-auto" data-id="element-8932">
          <table className="w-full" data-id="element-8933">
            <thead data-id="element-8934">
              <tr className="border-b border-gray-200" data-id="element-8935">
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8936">
                  Product Line
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8937">
                  SKU
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8938">
                  Revenue
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8939">
                  Cost
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8940">
                  Margin %
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8941">
                  Volume
                </th>
              </tr>
            </thead>
            <tbody data-id="element-8942">
              {skuData.map((item, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-8943">
                  <td className="py-3 px-4" data-id="element-8944">
                    <span className="inline-flex px-2 py-1 rounded text-xs font-medium text-white" style={{
                  backgroundColor: getLineColor(item.productLine)
                }} data-id="element-8945">
                      {item.productLine}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-800" data-id="element-8946">
                    {item.sku}
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-8947">
                    ₹{item.revenue} Cr
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-8948">
                    ₹{item.cost} Cr
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-green-600" data-id="element-8949">
                    {item.margin}%
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-8950">
                    {item.volume.toLocaleString()}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
};
export default ProductLinePerformanceDashboard;